import Core from 'src/Core'
import { getType, getUuid } from 'src/initializers/Utils'

import BatchUploader from 'src/ressources/BatchUploader'

export default class {
  constructor () {
    this._isInitialized = false
  }
  isInitialized () {
    return this._isInitialized
  }

  init (clientId, clientSecret, redirectUrl) {
    const publicMethodName = 'init'
    Core.validateParam(publicMethodName, clientId, { presence: true, message: 'clientId must be present' })
    Core.validateParam(publicMethodName, clientSecret, { presence: true, message: 'clientSecret must be present' })
    Core.validateParam(publicMethodName, clientId, { type: 'string', message: 'clientId must be a string' })
    Core.validateParam(publicMethodName, clientSecret, { type: 'string', message: 'clientSecret must be a string' })
    // Core.validateParam(publicMethodName, redirectUrl,  { type: 'string', message: 'redirectUrl must be a string' });

    Core.initController('Api', { clientId, clientSecret, redirectUrl })
    this._isInitialized = true
    return Promise.resolve()
  }

  isAuthorized () {
    return Core.execute('Api', 'isAuthorized')
  }

  authorizeUserWithIdentifier () {
    return Core.publicWrapper({
      name: 'authorizeUserWithIdentifier',
      arguments: arguments,
      parameters: ['userExternalId', 'userEmail', 'onSuccess', 'onFailure', 'onComplete', 'customFields'],
      validations: [
        { type: 'string', name: 'userExternalId' },
        { type: 'string', name: 'userEmail' },
        { type: 'object', name: 'customFields' },
      ],
    })
  }

  uploadWithFileInput () {
    return Core.publicWrapper({
      name: 'authorizeUserWithIdentifier',
      arguments: arguments,
      parameters: ['eans', 'inputId', 'onProgress', 'onSuccess', 'onFailure', 'onComplete', 'customFields', 'offerIdentifiers'],
      validations: [
        { type: 'array',  name: 'eans' },
        { type: 'string', name: 'inputId' },
        { type: 'object', name: 'customFields' },
        { type: 'array',  name: 'offerIdentifiers' },
      ],
    }, async function wrapped (params) {
      // TODO: next major
      // drop "inputId" in favor of "files"
      const domInput = global.document.getElementById(params.inputId)
      Core.validateParam('uploadWithFileInput', domInput,
        { name: 'inputId', presence: true, message: 'no input element #' + params.inputId })
      Core.validateParam('uploadWithFileInput', domInput.files,
        { name: 'inputId', presence: true, message: 'this input #' + params.inputId + ' is not a file input' })
      Core.validateParam('uploadWithFileInput', domInput.files.length,
        { name: 'inputId', notEqual: 0, message: 'no file in this input #' + params.inputId })

      // global promise contains three atomic API calls that can go wrong
      // when one of them fails, all following will be interrupted (chained `then()` will never be executed)
      // but we only want to reject the global promise (and not stop chained `then()` on it)
      return new Promise(async (resolve, reject) => {
        const capturedAt = new Date()

        const user = Core.getRessource('User')
        if (!user) { return reject(Core.missingUserError()) }

        const uuid = getUuid({ capturedAt, userId: user.get('id') })
        const receiptSubpicturesCount = domInput.files.length

        let receiptId
        try {
          const { eans, customFields, offerIdentifiers } = params
          const data = await Core.execute('Api', 'createReceiptV2',
            { uuid, eans, capturedAt, receiptSubpicturesCount, customFields, offerIdentifiers })
          receiptId = data.receipt_id
        } catch (error) {
          return reject(error)
        }

        try {
          await Core.execute('Api', 'uploadSubpicture', { receiptId, uuid, files: domInput.files, onProgress: params.onProgress })
          resolve(uuid)
        } catch (error) {
          reject(error)
        }
      })
    })
  }

  uploadWithIframe () {
    return Core.publicWrapper({
      name: 'uploadWithIframe',
      arguments: arguments,
      parameters: ['eans', 'iframeId', 'onSuccess', 'onFailure', 'onComplete', 'customFields'],
      validations: [
        { name: 'customFields', type: 'object' },
        { name: 'eans', undef: false },
        { name: 'iframeId', presence: true, message: 'no HTML ID for the iframe has been provided' },
        { name: 'iframeId', type: 'string' },
        { name: 'iframeId', undef: false, message: 'no HTML ID for the iframe has been provided' },
      ],
    }, async function wrapped (params) {
      const { eans, iframeId, customFields } = params

      const eansType = getType(eans)
      if (
        (typeof eans !== 'undefined') &&
        (eans !== null) &&
        (eans !== true) &&
        (eans !== false) &&
        (eansType !== 'array')
      ) {
        const message = 'parameter "eans" can not be ' + (eansType === 'object' ? 'an ' : 'a ') + eansType
        Core.throwInvalidParameter(message, { parameter: 'eans', reason: 'wrong_type' })
      }

      return Core.execute('Api', 'initIframe', { eans, iframeId, customFields })
    })
  }

  bulkUploadWithFileInput () {
    return Core.publicWrapper({
      name: 'bulkUploadWithFileInput',
      arguments: arguments,
      parameters: ['inputId', 'onProgress', 'onSuccess', 'onFailure', 'onComplete'],
      validations: [
        { type: 'string', name: 'inputId' },
      ],
    }, async function wrapped (params) {
      // TODO: next major
      // drop "inputId" in favor of "files"
      const domInput = global.document.getElementById(params.inputId)
      Core.validateParam('uploadWithFileInput', domInput,
        { presence: true, message: 'no input element #' + params.inputId })
      Core.validateParam('uploadWithFileInput', domInput.files,
        { presence: true, message: 'this input #' + params.inputId + ' is not a file input' })
      Core.validateParam('uploadWithFileInput', domInput.files.length,
        { notEqual: 0, message: 'no file in this input #' + params.inputId })

      const user = Core.getRessource('User')
      if (!user) { throw Core.missingUserError() }

      const uuids = new Set()
      while (uuids.size < domInput.files.length) {
        uuids.add(getUuid({ userId: user.get('id') }))
      }

      return Core.execute('Api', 'bulkUpload', { uuids: Array.from(uuids), files: domInput.files, onProgress: params.onProgress })
    })
  }

  getBatchUploader () {
    return new BatchUploader()
  }
}



// WEBPACK FOOTER //
// ./src/components/Base.js